import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import SidebarItem from "./SidebarItem";
import SidebarItemBlock from "./SidebarItemBlock";
import ConnectBar from "./ConnectBar";
import ReferralBar from "./ReferralBar";
import Settings from "./Settings";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faHandHoldingDollar, faSackDollar, faWallet, faChartSimple, faChartPie, faServer, faWifi, faCoins, faUsers, faLink, faClone, faGear, faXmark, faLayerGroup } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AccountInfo from "./AccountInfo";
import UpgradeModal from "./UpgradeModal";

function Sidebar({title, isOpen, toggleSidebar, toggleSettingsBar, settingsBar }) {
  const currentPath = window.location.pathname;
  const { user } = useUser();
  const [referralBar, setReferralBar] = useState(false);
  const [connectBar, setConnectBar] = useState(false);
  const toggleReferralBar = () => {
    setReferralBar(!referralBar);
  };
  const toggleConnectBar = () => {
    setConnectBar(!connectBar);
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
    return (
      <>
        {!isMobile ? (
          <div className={`col-auto sidebar`}>
            <div className="w-100">
              <div className="d-flex align-items-center justify-content-between">
                <img src={logo} alt="logo" className="app-logo"/>
                <FontAwesomeIcon className="d-block d-md-none" icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>
              </div>
              <div className="sidebar-navbar">
                <SidebarItem icon={<FontAwesomeIcon icon={faHouse} />} label="Dashboard" isActive={(title === "Dashboard")?true:false} link="/dashboard" />
                <SidebarItem icon={<FontAwesomeIcon icon={faHandHoldingDollar} />} label="Deposit" isActive={(title === "Deposit")?true:false} link="/deposit" />
                <SidebarItem icon={<FontAwesomeIcon icon={faSackDollar} />} label="Withdraw" isActive={(title === "Withdraw")?true:false} link="/withdraw" />
                <SidebarItem icon={<FontAwesomeIcon icon={faWallet} />} label="Assets" isActive={(title === "Assets")?true:false} link="/assets" />
                <SidebarItem icon={<FontAwesomeIcon icon={faChartPie} />} label="Markets" isActive={(title === "Markets")?true:false} link="/markets" />
                <SidebarItem icon={<FontAwesomeIcon icon={faLayerGroup} />} label="Stocks" isActive={(title === "Stocks")?true:false} link="/stock" />
                <SidebarItem icon={<FontAwesomeIcon icon={faCoins} />} label="Mining" isActive={(title === "Mining")?true:false} link="/mining" />
                <SidebarItem icon={<FontAwesomeIcon icon={faChartSimple} />} label="Trade" isActive={(title === "Trade")?true:false} link="/trade" />
                <SidebarItem icon={<FontAwesomeIcon icon={faServer} />} label="Subscribe" isActive={(title === "Subscribe")?true:false} link="/subscribe" />
                <SidebarItem icon={<FontAwesomeIcon icon={faWifi} />} label="Signals" isActive={(title === "Signals")?true:false} link="/signal" />
                {user?.account_type != "Stock" && (
                <SidebarItem icon={<FontAwesomeIcon icon={faCoins} />} label="Stake" isActive={(title === "Stake")?true:false} link="/stake" />
                )}
                <SidebarItem icon={<FontAwesomeIcon icon={faUsers} />} label="Referrals" isActive={(title === "Referrals")?true:false} onClick={() => {toggleReferralBar()}} />
                <SidebarItem icon={<FontAwesomeIcon icon={faLink} />} label="Connect wallet" isActive={(title === "Connect wallet")?true:false} onClick={() => {toggleConnectBar()}}  />
                <SidebarItem icon={<FontAwesomeIcon icon={faClone} />} label="Copy Experts" isActive={(title === "Copy Experts")?true:false} link="/copyexpert" />
                <SidebarItem icon={<FontAwesomeIcon icon={faGear} />} label="Settings" isActive={(title === "Settings")?true:false} onClick={() => {toggleSettingsBar()}} />
              </div>
            </div>
            <div className="account-card">
              <div
                className="d-flex align-items-center justify-content-center me-2 rounded-2 oveflow-hidden"
                style={{ width: "32px", height: "32px", backgroundColor: '#ffffff0d', borderRadius: '6px', color: '#f80',  }}>
                                    {user.photo == "" ? (
                        <span className="fw-semibold">{user?.fullname?.substring(0, 2)}</span>
                    ) : (
                        <img src={`/uploads/${user.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                    )}  
              </div>
              <div>
                <div className="small fw-bold">{user?.fullname}</div>
                <div className="fs-7 text-secondary">{user?.subscription}</div>
              </div>
            </div>
          </div>
        ) : (
          <div className={`mobilesidebar ${isOpen ? "active" : null}`}>
            <div className="w-100">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center me-2 rounded-2 overflow-hidden"
                    style={{ width: "32px", height: "32px", backgroundColor: '#ffffff0d', borderRadius: '6px', color: '#f80',  }}>
                    {user.photo == "" ? (
                        <span className="fw-semibold">{user?.fullname?.substring(0, 2)}</span>
                    ) : (
                        <img src={`/uploads/${user.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                    )}                    
                  </div>
                  <div>
                    <div className="small fw-bold">{user?.fullname}</div>
                    <div className="fs-7 fw-bold text-secondary">{user?.subscription}</div>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faGear} className="me-4" style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleSettingsBar()}} />
                  <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={toggleSidebar}/>
                </div>
              </div>
              <Slider {...settings}>
                <div>
                  <div className="mobilesidebar-navbar">
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faHouse} />} label="Dashboard" isActive={(title === "Dashboard")?true:false} link="/dashboard" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faHandHoldingDollar} />} label="Deposit" isActive={(title === "Deposit")?true:false} link="/deposit" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faSackDollar} />} label="Withdraw" isActive={(title === "Withdraw")?true:false} link="/withdraw" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faWallet} />} label="Assets" isActive={(title === "Assets")?true:false} link="/assets" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faChartPie} />} label="Markets" isActive={(title === "Markets")?true:false} link="/markets" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faLayerGroup} />} label="Stocks" isActive={(title === "Stocks")?true:false} link="/stock" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faCoins} />} label="Mining" isActive={(title === "Mining")?true:false} link="/mining" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faChartSimple} />} label="Trade" isActive={(title === "Trade")?true:false} link="/trade" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faServer} />} label="Subscribe" isActive={(title === "Subscribe")?true:false} link="/subscribe" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faWifi} />} label="Signals" isActive={(title === "Signals")?true:false} link="/signal" />
                    {user?.account_type != "Stock" && (
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faCoins} />} label="Stake" isActive={(title === "Stake")?true:false} link="/stake" />
                    )}
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faUsers} />} label="Referrals" isActive={(title === "Referrals")?true:false} onClick={() => {toggleReferralBar()}} />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faLink} />} label="Connect wallet" isActive={(title === "Connect wallet")?true:false} onClick={() => {toggleConnectBar()}}  />
                  </div>
                </div>
                <div>
                  <div className="mobilesidebar-navbar">
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faClone} />} label="Copy Experts" isActive={(title === "Copy Experts")?true:false} link="/copyexpert" />
                    <SidebarItemBlock icon={<FontAwesomeIcon icon={faGear} />} label="Settings" isActive={(title === "Settings")?true:false} onClick={() => {toggleSettingsBar()}} />
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        )}
        <AccountInfo UserDetails={user}/>
        <UpgradeModal UserDetails={user} currentPath={currentPath} />
        <ReferralBar toggleReferralBar={toggleReferralBar} referralBar={referralBar}/>
        <ConnectBar toggleConnectBar={toggleConnectBar} connectBar={connectBar}/>
        <Settings toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
      </>
    )
}

export default Sidebar